import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from 'react-simple-captcha';
import { PageSettings } from '../../config/page-settings.js';
import withNotification from '../../components/HOCNotification/HOCNotification.component';

import { COPYRIGHT, RESPONSE } from '../../config/constants';
import Services from '../../services/service';
import UserProfile from '../../services/userProfile.js';

const { SUCCESS, FAILED, INVALID } = RESPONSE;
const userProfile = new UserProfile();

class ForgotPassword extends React.Component {
  static contextType = PageSettings;

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      captchaVerify: '',
      formErrors: [],
      submitLoading: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetBodyWhiteBg(true);
    loadCaptchaEnginge(5, '#348fe2', 'white');
  }

  componentWillUnmount() {
    this.context.handleSetPageSidebar(true);
    this.context.handleSetPageHeader(true);
    this.context.handleSetBodyWhiteBg(false);
  }

  handleChange = (e) => {
    const {name, value} = e.target;
    const state = { [name]: value };
    this.setState(state);
  };

  handleSubmit(e) {
    e.preventDefault();
    let validate = this.validateForm();
    if (validate) {
      this.postForgotPassword();
    }
  }

  renderCaptcha() {
    return <LoadCanvasTemplate reloadColor="#348fe2" />;
  }

  validateForm() {
    let errors = [];
    if (this.state.username === '') {
      errors.push('username');
    }
    if (this.state.captchaVerify === '') {
      errors.push('captchaVerify');
    }

    this.setState({
      formErrors: errors,
    });

    if (errors.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  hasError(key) {
    return this.state.formErrors.indexOf(key) !== -1;
  }

  postForgotPassword = async () => {
    const { username, captchaVerify } = this.state;
    const payload = { username };

    if (!validateCaptcha(captchaVerify)) {
      this.props.toggleNotification(INVALID, 'Captcha tidak sesuai');
      this.setState({captchaVerify: ''});
      return;
    }

    this.setState({ submitLoading: true });

    userProfile.setUsername(username);

    await Services.postForgotPassword(payload)
      .then((res) => {
        this.props.toggleNotification(SUCCESS);
        this.setState({ submitLoading: false });
        setTimeout(this.props.history.push('/login/change-password'), 3000);
      })
      .catch((err) => {
        const parseErr = JSON.parse(err.request.response);
        this.props.toggleNotification(FAILED, parseErr.error);
        this.setState({ submitLoading: false });
        return;
      });
  };

  render() {
    const { username, submitLoading, captchaVerify } = this.state;
    return (
      <div className="login login-with-news-feed">
        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: 'url(/assets/img/login-bg/login-image.jpg)',
            }}
          ></div>
          <div className="news-caption"></div>
        </div>
        <div className="right-content">
          <div className="login-header">
            <div className="brand">
              <h1>Lupa Password</h1>
            </div>
            <div className="icon">
              <i className="fa fa-sign-in"></i>
            </div>
          </div>
          <div className="login-content">
            <form className="margin-bottom-0" onSubmit={this.handleSubmit}>
              <div className="form-group m-b-15">
                <input
                  type="email"
                  className={`form-control form-control-lg ${
                    this.hasError('username') ? 'is-invalid' : ''
                  }`}
                  placeholder="Username"
                  name="username"
                  onChange={this.handleChange}
                  value={username}
                />
                <div className="invalid-feedback">
                  {'Username wajib diisi.'}
                </div>
              </div>
              <div className="row form-group m-b-30 text-center">
                <div className="col-lg-7 col-md-6 col-sm-7 col-xs-6">
                  <input
                    type="text"
                    className={`form-control form-control-lg ${
                      this.hasError('captchaVerify') ? 'is-invalid' : ''
                    }`}
                    placeholder="Captcha Code"
                    name="captchaVerify"
                    onChange={this.handleChange}
                    value={captchaVerify}
                  />
                  <div className="invalid-feedback">Captcha wajib diisi.</div>
                </div>
                <div className="col-lg-5 col-md-6 col-sm-5 col-xs-6 mt-2">
                  {this.renderCaptcha()}
                </div>
              </div>
              <div className="login-buttons m-b-5">
                <button
                  type="submit"
                  className="btn btn-blue btn-block btn-lg"
                  disabled={submitLoading}
                >
                  {submitLoading ? (
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    'Kirim OTP'
                  )}
                </button>
              </div>
              <div className="login-buttons">
                <Link
                  to="/login"
                  className="btn btn-success btn-block btn-lg"
                  disabled={submitLoading}
                >
                  Kembali ke Halaman Login
                </Link>
              </div>
              <hr />
              <p className="text-center text-grey-darker">
                {COPYRIGHT}
              </p>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withNotification(withRouter(ForgotPassword));
